export const capitalizeWord = (word) => {
    if (!word) return ''
    // convert word to small case
    const smallCaseWord = word.toLowerCase()
    return smallCaseWord.charAt(0).toUpperCase() + smallCaseWord.slice(1)
}

export const separateWord = (word) =>
    word.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase()
